import { useDispatch } from "react-redux";
import { setSelectedPage, cleanSelectedPage } from "./menuSlice";

export default function MenuService() {
  const dispatch = useDispatch();

  const selectPage = (pageKey: string) => {
    dispatch(setSelectedPage({ page: pageKey }));
  };

  const cleanPage = () => {
    dispatch(cleanSelectedPage());
  };

  return {
    selectPage,
    cleanPage,
  };
}
